import type { SelectOption } from '@/features/class/manage/types';

export const ACADEMIC_YEAR_OPTION_COUNT = 10;

/**
 * Builds academic years from the next calendar year backwards.
 *
 * For example, 2026 produces 2027-2028 through 2018-2019.
 */
export function buildAcademicYearOptions(
  currentYear = new Date().getFullYear(),
): readonly SelectOption[] {
  return Array.from({ length: ACADEMIC_YEAR_OPTION_COUNT }, (_, index) => {
    const startYear = currentYear + 1 - index;
    const academicYear = `${startYear}-${startYear + 1}`;

    return { id: academicYear, label: academicYear };
  });
}

/** Generated locally until the backend provides academic years. */
export const MOCK_ACADEMIC_YEARS: readonly SelectOption[] = buildAcademicYearOptions();

/** Placeholder until backend provides subjects (searchable in the form). */
export const MOCK_SUBJECTS: readonly SelectOption[] = [
  { id: 'mathematics', label: 'Mathematics' },
  { id: 'algebra', label: 'Algebra' },
  { id: 'geometry', label: 'Geometry' },
  { id: 'calculus', label: 'Calculus' },
  { id: 'statistics', label: 'Statistics' },
  { id: 'english', label: 'English' },
  { id: 'english-literature', label: 'English Literature' },
  { id: 'creative-writing', label: 'Creative Writing' },
  { id: 'science', label: 'Science' },
  { id: 'general-science', label: 'General Science' },
  { id: 'physics', label: 'Physics' },
  { id: 'chemistry', label: 'Chemistry' },
  { id: 'biology', label: 'Biology' },
  { id: 'environmental-science', label: 'Environmental Science' },
  { id: 'history', label: 'History' },
  { id: 'world-history', label: 'World History' },
  { id: 'geography', label: 'Geography' },
  { id: 'economics', label: 'Economics' },
  { id: 'business-studies', label: 'Business Studies' },
  { id: 'computer-science', label: 'Computer Science' },
  { id: 'information-technology', label: 'Information Technology' },
  { id: 'art', label: 'Art' },
  { id: 'music', label: 'Music' },
  { id: 'physical-education', label: 'Physical Education' },
  { id: 'health-education', label: 'Health Education' },
  { id: 'french', label: 'French' },
  { id: 'spanish', label: 'Spanish' },
  { id: 'arabic', label: 'Arabic' },
  { id: 'religious-studies', label: 'Religious Studies' },
  { id: 'philosophy', label: 'Philosophy' },
] as const;

/** Placeholder until backend provides grade/year levels. */
export const MOCK_GRADE_LEVELS: readonly SelectOption[] = [
  { id: 'pre-k', label: 'Pre-K' },
  { id: 'kg', label: 'KG' },
  { id: '1', label: '1' },
  { id: '2', label: '2' },
  { id: '3', label: '3' },
  { id: '4', label: '4' },
  { id: '5', label: '5' },
  { id: '6', label: '6' },
  { id: '7', label: '7' },
  { id: '8', label: '8' },
  { id: '9', label: '9' },
  { id: '10', label: '10' },
  { id: '11', label: '11' },
  { id: '12', label: '12' },
] as const;

export function findOptionLabel(options: readonly SelectOption[], id: string): string | undefined {
  return options.find((option) => option.id === id)?.label;
}
